import React from 'react';
import { useAuth } from '../../modules/auth/AuthContext';
import { Link } from 'react-router-dom'; // React Routerを使用する場合

function Myplan() {
  const { subscriptions } = useAuth();

  // 日付のフォーマット関数（必要に応じてカスタマイズ）
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  };

  return (
    <>
      <div className="myplanContainer">
        <div className="myplan">
          {subscriptions.chatbotPremium && (
            <div>
              <h2>あなたのプラン：プレミアム</h2>
              <p>前回支払い：{formatDate(subscriptions.chatbotPremium.expires_at)}</p>
              <Link to="https://hangul-match.com/chatbot/subscription/cancel"><p>サブスクをキャンセルする</p></Link>
            </div>
          )}

          {subscriptions.chatbotStandard && !subscriptions.chatbotPremium && (
            <div>
              <h2>あなたのプラン：スタンダード</h2>
              <p>前回支払い：{formatDate(subscriptions.chatbotStandard.expires_at)}</p>
              <p>プレミアムプランにアップグレードしたい場合は、一度、サブスクリプションを解約する必要がございます。</p>
              <Link to="https://hangul-match.com/chatbot/subscription/cancel"><p>サブスクをキャンセルする</p></Link>
            </div>
          )}

          {!subscriptions.chatbotStandard && !subscriptions.chatbotPremium && (
            <div>
              <h2>あなたのプラン：フリー</h2>
              <Link to="https://hangul-match.com/chatbot/subscription"><p>プレミアムプランに契約する</p></Link>
              <Link to="https://hangul-match.com/chatbot/subscription/standard">スタンダードプランに契約する</Link>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Myplan;